import { Client } from '@fiizy/auth'
import apiUrl from '@/utils/apiUrl'
import clientData from '@/utils/clientData'

export default new Client({
  apiUrl: apiUrl(),
  clientData
})
